import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { getDummyText } from "../../../utils";

export const highlights = [
    {
        header: "Festkörperlaser 1",
        bodyText: getDummyText(200),
        linkText: "Mehr erfahren",
        link: "#",
    },
    {
        header: "CO2-Laser 2",
        bodyText: getDummyText(90),
        linkText: "Mehr erfahren",
        link: "#",
    },
    {
        header: "Lorem ipsum dolor 3 sit amet long title",
        bodyText: getDummyText(220),
        linkText: "Mehr erfahren",
        link: "#",
    },
    {
        header: "Sed ut perspiciatis 4",
        bodyText: getDummyText(110),
        linkText: "Mehr erfahren",
        link: "#",
    },
    {
        header: "Nemo enim ipsam volupta 5",
        bodyText: getDummyText(190),
        linkText: "Mehr erfahren",
        link: "#",
    },
    {
        header: "Neque porro quisquam 6",
        bodyText: getDummyText(280),
        linkText: "Mehr erfahren",
        link: "#",
    },
    {
        header: "Neque porro quisquam 7",
        bodyText: getDummyText(140),
        linkText: "Mehr erfahren",
        link: "#",
    },
];

const defaultStoryArgs = {
    header: "Trumpf Highlights",
    sideLayout: false,
    subheader: "The details of our products",
    bodytext: getDummyText(220),
    highlights: highlights,
    extraHighlight: false,
    withSlider: false,
    noLink: false,
    marginalColumn: false,
    isSourceCode: false,
};

export default {
    title: "Website/Partial Templates/Highlights (B.5)",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    excludeStories: ["highlights"],
    args: { ...defaultStoryArgs },
    argTypes: {
        header: { control: "text" },
        sideLayout: { control: "boolean" },
        subheader: { control: "text" },
        bodytext: { control: "text" },
        extraHighlight: { control: "boolean" },
        withSlider: { control: "boolean" },
        noLink: { control: "boolean" },
        marginalColumn: { control: "boolean" },
    },
};

const Template = (args = defaultStoryArgs) => {
    const template = html`
        <!-- insert here TRUMPF HEADER VIEWHELPER, already included in TYPO3 Partial -->
        <div class="row">
            <div
                class="gr-10 push-1 gr-12@m push-0@m u-marginBottom-30 u-marginTop-60"
            >
                ${!args.sideLayout
                    ? html`
                          <div
                              class="gblock-header gr-10 push-1 u-textCenter gr-10@t push-1@t gr-12@m push-0@m u-headline-inModule"
                          >
                              <h3 class="headline-small">${args.subheader}</h3>
                              <div
                                  class="text-normal u-color-gray-paragraph u-marginTop-em"
                              >
                                  ${args.bodytext}
                              </div>
                          </div>
                          <div
                              class="block-content gr-12 gr-12@t gr-12@m no-gutter@t no-gutter@m u-clearfix u-marginTop-35 u-headline-inModule"
                              data-sameheight="group"
                          >
                              ${teasers(args)}
                          </div>
                      `
                    : html`
                          <div
                              class="gr-6 gr-10@t push-1@t gr-12@m push-1@m u-marginBottom-60"
                          >
                              <h3 class="headline-small">${args.subheader}</h3>
                              <div
                                  class="text-normal u-color-gray-paragraph u-marginTop-em"
                              >
                                  ${args.bodytext}
                              </div>
                          </div>
                          <div
                              class="gr-6 gr-12@t gr-12@m no-gutter@t no-gutter@m u-clearfix"
                              data-sameheight="group"
                          >
                              ${teasers(args)}
                          </div>
                      `}
            </div>
        </div>
    `;
    return template;
};

export const Default = Template.bind({});

export const TemplateWithSlider = (args = defaultStoryArgs) => {
    const template = html`
        <!-- insert here TRUMPF HEADER VIEWHELPER, already included in TYPO3 Partial -->
        <div class="ux-t-container">
            <div class="ux-row">
                <div
                    class="ux-col ux-col-md-10 ux-u-offset-md-1 ux-u-pt-fluid-m ux-u-pb-fluid-m"
                >
                    ${args.subheader
                        ? html`
                              <h3
                                  class="ux-text-headline ux-text-headline--medium"
                              >
                                  ${args.subheader}
                              </h3>
                          `
                        : html``}
                    ${args.bodytext
                        ? html`
                              <div
                                  class="ux-text-normal ux-text-normal--light-gray"
                              >
                                  ${args.bodytext}
                              </div>
                          `
                        : html``}
                </div>
            </div>
        </div>
        <div class="ux-t-container-full">
            <div class="ux-row">
                <div class="ux-col">
                    <ux-slider
                        no-arrows
                        slides-auto-height
                        slides-overflow-visible
                        space-between-s="10"
                        space-between-m="20"
                        space-between-l="30"
                        space-between-xl="30"
                        visible-slides-m="2"
                        visible-slides-l="2"
                        visible-slides-xl="3"
                        slides-per-column-l="${args.marginalColumn ? `3` : `1`}"
                        slides-per-column-xl="20"
                        container-width-s="83.33%"
                        container-width-m="83.33%"
                        container-width-l="83.33%"
                        container-width-xl="83.33%"
                        reinit-on-resize
                        breakpoint-s="1023"
                        breakpoint-m="1439"
                        breakpoint-l="${args.marginalColumn ? `1600` : `1439`}"
                        container-classes="ux-u-background-grey u-paddingBottom-50 u-paddingTop-50 ux-u-py-xl"
                        slides-per-column-fill="row"
                        slides-auto-height
                    >
                        ${args.highlights.map((highlight) => {
                            return html`
                                <ux-slider-slide
                                    class="ux-u-background-white ux-u-shadow ux-u-margin-vertical-15"
                                >
                                    <div
                                        class="ux-u-margin-vertical-25 ux-u-margin-horizontal-30 ux-u-margin-xl-vertical-45 ux-u-margin-xl-horizontal-50"
                                    >
                                        <div data-same-height="text">
                                            <div
                                                class="ux-text-title ux-text-title--green-square ux-text-title--bold ux-u-margin-bottom-10"
                                            >
                                                ${highlight.header}
                                            </div>
                                            <div
                                                class="ux-text-normal ux-text-normal--light-gray ux-u-margin-children-0"
                                            >
                                                <p>${highlight.bodyText}</p>
                                            </div>
                                        </div>
                                        ${args.noLink
                                            ? html``
                                            : html`<div
                                                  class="ux-u-margin-top-10"
                                              >
                                                  <a
                                                      href="${highlight.link}"
                                                      class="ux-text-link ux-text-link--green"
                                                  >
                                                      <span
                                                          >${highlight.linkText}</span
                                                      >
                                                      <ux-icon
                                                          name="arrow-small-right"
                                                      ></ux-icon>
                                                  </a>
                                              </div>`}
                                    </div>
                                </ux-slider-slide>
                            `;
                        })}
                        <ux-slider-pagination
                            slot="pagination"
                            bottom-pagination
                        >
                        </ux-slider-pagination>
                    </ux-slider>
                </div>
            </div>
        </div>
    `;
    return template;
};

const teasers = (args = defaultStoryArgs) => {
    return html`
        <ux-same-height class="row">
            ${highlightTeaser(highlights[0], args.noLink)}
            ${highlightTeaser(highlights[1], args.noLink)}
        </ux-same-height>
        <ux-same-height class="row">
            ${highlightTeaser(highlights[2], args.noLink)}
            ${highlightTeaser(highlights[3], args.noLink)}
        </ux-same-height>
        <ux-same-height class="row">
            ${highlightTeaser(highlights[4], args.noLink)}
            ${highlightTeaser(highlights[5], args.noLink)}
        </ux-same-height>
        ${args.extraHighlight
            ? html`
                  <ux-same-height class="row">
                      ${highlightTeaser(highlights[4], args.noLink)}
                  </ux-same-height>
              `
            : html``}
    `;
};

const highlightTeaser = (highlight, noLink) => {
    return html`
        <div class="gr-6 gr-12@m ux-u-margin-bottom-25">
            <div data-same-height="content" class="ux-u-margin-bottom-10">
                <span
                    class="ux-text-title ux-text-title--green-square ux-text-title--bold"
                >
                    ${highlight.header}
                </span>
                <div class="ux-text-normal">
                    <p>${highlight.bodyText}</p>
                </div>
            </div>
            ${noLink
                ? html``
                : html`
                      <div class="u-clearfix ux-u-margin-bottom-20">
                          <a href="#" class="ux-text-link ux-text-link--green">
                              <span> Mehr erfahren </span>
                              <ux-icon
                                  name="arrow-right"
                                  weight="normal"
                              ></ux-icon>
                          </a>
                      </div>
                  `}
            <div class="ux-u-border-top"></div>
        </div>
    `;
};
